// extracted by mini-css-extract-plugin
export default {"root":"CurrencyField_root__qCCf+","sub-text":"CurrencyField_sub-text__2zZRl","edit-button":"CurrencyField_edit-button__WdVXw","inline-input":"CurrencyField_inline-input__KCY23"};